module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar-expand navbar-light bg-light"
  }, [_c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarNav"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/services"
    }
  }, [_vm._v("MOJE SLUŽBY")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/devices"
    }
  }, [_vm._v("MOJE KONCOVÁ ZAŘÍZENÍ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/account"
    }
  }, [_vm._v("MŮJ ÚČET"), (_vm.nedoplatek) ? _c('span', {
    staticClass: "badge badge-pill badge-danger",
    attrs: {
      "id": "nedoplatek"
    }
  }, [_vm._v("-" + _vm._s(_vm.nedoplatek) + " Kč")]) : _vm._e()])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/findocs"
    }
  }, [_vm._v("MOJE FAKTURY")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/personal"
    }
  }, [_vm._v("OSOBNÍ ÚDAJE")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/referral"
    }
  }, [_vm._v("DOPORUČ & ZÍSKEJ")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00512f14","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 299
// module chunks = 1 2